(() => {
  const drawer = document.querySelector('header-drawer');
  const panel = drawer?.querySelector('.rc-brand-mobile-panel');
  if (!panel || typeof drawer.closeAnimation !== 'function') return;
  const brandDetails = panel.closest('details');
  const original = drawer.closeAnimation.bind(drawer);
  drawer.closeAnimation = function(details) {
    if (details !== brandDetails) return original(details);
    details.removeAttribute('open');
    const parent = details.parentElement.closest('details[open]');
    if (parent && typeof trapFocus === 'function') trapFocus(parent, details.querySelector('summary'));
  };
})();
